import { createRootRouteWithContext } from "@tanstack/react-router"
import type { AuthContextValue } from "@mimber/auth"
import { RootLayout } from "@/components/layouts"

export interface MyRouterContext {
  auth: AuthContextValue
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootLayout,
})
